import { useQuery } from '@tanstack/react-query';
import { fetchLocations } from '@/api/iam';
import type { TrLocation } from '@/lib/locations';

const NO_LOCATIONS: readonly TrLocation[] = [];

/**
 * Il/ilce listesi — statik veri, oturum boyunca bir kez cekilir. Yuklenene kadar bos liste:
 * secici "yukleniyor" gibi davranir, dogrulama atlanir (lib/locations refineLocation).
 */
export const useLocations = (): readonly TrLocation[] => {
  const query = useQuery({
    queryKey: ['locations'],
    queryFn: fetchLocations,
    staleTime: Infinity,
    gcTime: Infinity,
  });
  return query.data ?? NO_LOCATIONS;
};
